import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/close_ic.svg';
const _withScopeId = n => (_pushScopeId("data-v-0ca85eee"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "filterGrayBg" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title font-36 font-w500" }, "筛选", -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { class: "listContent p-b32 border-box" };
const _hoisted_7 = {
    key: 0,
    class: "list p-lr32 border-box"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "筛选", -1));
const _hoisted_9 = { class: "parent clearfix" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
    key: 1,
    class: "list p-lr32 border-box"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "课程类型", -1));
const _hoisted_13 = {
    key: 0,
    class: "parent clearfix"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "children clearfix" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 1,
    class: "parent clearfix"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "list p-lr32 border-box" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "亚专业", -1));
const _hoisted_21 = { class: "parent clearfix" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "children clearfix" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
    key: 2,
    class: "list p-lr32 border-box"
};
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "排序", -1));
const _hoisted_27 = { class: "parent clearfix" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
    key: 3,
    class: "list p-lr32 border-box"
};
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "报名状态", -1));
const _hoisted_31 = { class: "parent clearfix" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { class: "list p-lr32 border-box" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "召开状态", -1));
const _hoisted_35 = { class: "parent clearfix" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = { class: "list p-lr32 border-box" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "召开状态", -1));
const _hoisted_39 = { class: "parent clearfix" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "list p-lr32 border-box" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-32 font-w500" }, "招生状态", -1));
const _hoisted_43 = { class: "parent clearfix" };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "btnBox flex p-lr32 font-w500" };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = ["onClick"];
import { ref, onMounted } from 'vue';
import { useVipList, useSubDep, useCourseType, totalCount, resetSearch, useBuy, useRank, comingList, activeComing, selectComing, useEnroll
// sendLocalData,
// courseLoading
 } from './search';
import { appPort } from '@/widget';
// import { Toast } from 'vant'
export default /*#__PURE__*/ _defineComponent({
    props: {
        courseType: {
            default: '',
            type: String
        },
        vip188: {
            default: false,
            type: Boolean
        }
    },
    emits: ['closeFilter'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const select = ref(true);
        // 会员
        const { vipList, selectVip, activeVip } = useVipList();
        // 亚专业
        const { selectSubDep, activeSubDep, subDepList, activeMeta, selectMeta, subDepInd } = useSubDep();
        const selectDepFn = (item, n) => {
            selectSubDep(item);
            subDepInd.value = n;
        };
        // 课程类型
        const { selectType, activeType, typeList, activeSubType, selectSubType, typeInd } = useCourseType();
        const selectTypeFn = (item, n) => {
            typeInd.value = n;
            selectType(item);
        };
        // 排序
        let { rankList, activeRank, selectRank } = useRank();
        // 是否购买
        let { buyList, activeBuy, selectBuy } = useBuy();
        const closeFn = () => {
            // if (appPort()) {
            //   if (courseLoading.value) {
            //     Toast('加载中请稍后')
            //     return
            //   }
            //   select.value = false
            //   sendLocalData()
            //   setTimeout(() => {
            //     appSelectedTypeAlert('')
            //   }, 300)
            // } else {
            if (select.value) {
                setTimeout(() => {
                    select.value = true;
                }, 320);
            }
            select.value = false;
            emits('closeFilter');
            // }
        };
        const { activeEnroll, selectEnroll, enrollList } = useEnroll();
        // 重置搜索
        const resetFn = () => {
            resetSearch();
        };
        onMounted(() => {
            if (appPort()) {
                totalCount.value = Number(localStorage.getItem('totalCount') || 0);
            }
        });
        //显示viptab
        const showVipTab = (vipId) => {
            if (!props.vip188) {
                return true;
            }
            else {
                if (vipId == 1) {
                    return true;
                }
            }
            return false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["filterContent", { linearUp: select.value, hideDown: !select.value, inApp: _unref(appPort)() }])
                }, [
                    _hoisted_2,
                    _createElementVNode("div", {
                        class: "closeBtn",
                        onClick: _withModifiers(closeFn, ["stop"])
                    }, _hoisted_5, 8, _hoisted_3),
                    _createElementVNode("div", _hoisted_6, [
                        (!/^(omo|open)$/.test(__props.courseType))
                            ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("dd", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vipList), (item, key) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                    active: _unref(activeVip)?.id == item.id,
                                                    'm-r0': (key + 1) % 3 == 0
                                                }]),
                                            onClick: _withModifiers(($event) => (_unref(selectVip)(item)), ["stop"])
                                        }, _toDisplayString(item.name), 11, _hoisted_10)), [
                                            [_vShow, showVipTab(item.id)]
                                        ]);
                                    }), 256))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!/^(omo|open)$/.test(__props.courseType))
                            ? (_openBlock(), _createElementBlock("dl", _hoisted_11, [
                                _hoisted_12,
                                (__props.courseType != 'master_class')
                                    ? (_openBlock(), _createElementBlock("dd", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_unref(typeList).length / 3), (n) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList).slice(3 * (n - 1), 3 * n), (item, key) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(["float-l text-overflow font-28 parent-item", { active: _unref(activeType)?.id == item.id, 'm-r0': key == 2 }]),
                                                        onClick: _withModifiers(($event) => (selectTypeFn(item, n)), ["stop"])
                                                    }, _toDisplayString(item.name), 11, _hoisted_14));
                                                }), 256)),
                                                _withDirectives(_createElementVNode("div", _hoisted_15, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeType)?.detailTypeList, (sub) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            class: _normalizeClass(["child float-l", { active: sub.id == _unref(activeSubType)?.id }]),
                                                            onClick: _withModifiers(($event) => (_unref(selectSubType)(sub)), ["stop"])
                                                        }, _toDisplayString(sub.name), 11, _hoisted_16));
                                                    }), 256))
                                                ], 512), [
                                                    [_vShow, _unref(typeInd) == n && _unref(activeType)?.detailTypeList.length]
                                                ])
                                            ], 64));
                                        }), 256))
                                    ]))
                                    : (_openBlock(), _createElementBlock("dd", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeType)?.detailTypeList, (item, key) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                        active: _unref(activeSubType)?.id == item.id,
                                                        'm-r0': (key + 1) % 3 == 0
                                                    }]),
                                                onClick: _withModifiers(($event) => (_unref(selectSubType)(item)), ["stop"])
                                            }, _toDisplayString(item.name), 11, _hoisted_18));
                                        }), 256))
                                    ]))
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("dl", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("dd", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_unref(subDepList).length / 3), (n) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subDepList).slice(3 * (n - 1), 3 * n), (item, key) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                        active: _unref(activeSubDep)?.id == item.id,
                                                        'm-r0': key == 2
                                                    }]),
                                                onClick: _withModifiers(($event) => (selectDepFn(item, n)), ["stop"])
                                            }, _toDisplayString(item.name), 11, _hoisted_22));
                                        }), 256)),
                                        _withDirectives(_createElementVNode("div", _hoisted_23, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeSubDep)?.knowledgeElementList, (sub) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass(["child float-l", { active: _unref(activeMeta)?.id == sub.id }]),
                                                    onClick: _withModifiers(($event) => (_unref(selectMeta)(sub)), ["stop"])
                                                }, _toDisplayString(sub.name), 11, _hoisted_24));
                                            }), 256))
                                        ], 512), [
                                            [_vShow,
                                                _unref(subDepInd) == n && _unref(activeSubDep)?.knowledgeElementList.length
                                            ]
                                        ])
                                    ], 64));
                                }), 256))
                            ])
                        ]),
                        (_unref(rankList))
                            ? (_openBlock(), _createElementBlock("dl", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("dd", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rankList), (item, key) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                    active: _unref(activeRank)?.id == item.id,
                                                    'm-r0': (key + 1) % 3 == 0
                                                }]),
                                            onClick: _withModifiers(($event) => (_unref(selectRank)(item)), ["stop"])
                                        }, _toDisplayString(item.name), 11, _hoisted_28));
                                    }), 256))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!/^open$/.test(__props.courseType))
                            ? (_openBlock(), _createElementBlock("dl", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("dd", _hoisted_31, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buyList), (item, key) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                    active: _unref(activeBuy)?.id == item.id,
                                                    'm-r0': (key + 1) % 3 == 0
                                                }]),
                                            onClick: _withModifiers(($event) => (_unref(selectBuy)(item)), ["stop"])
                                        }, _toDisplayString(item.name), 11, _hoisted_32));
                                    }), 256))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("dl", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("dd", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comingList), (item, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                active: _unref(activeComing)?.id === item.id,
                                                'm-r0': (key + 1) % 3 == 0
                                            }]),
                                        onClick: _withModifiers(($event) => (_unref(selectComing)(item)), ["stop"])
                                    }, _toDisplayString(item.name), 11, _hoisted_36));
                                }), 256))
                            ])
                        ], 512), [
                            [_vShow, _unref(activeType)?.id == 'omo']
                        ]),
                        _withDirectives(_createElementVNode("dl", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("dd", _hoisted_39, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comingList), (item, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                active: _unref(activeComing)?.id === item.id,
                                                'm-r0': (key + 1) % 3 == 0
                                            }]),
                                        onClick: _withModifiers(($event) => (_unref(selectComing)(item)), ["stop"])
                                    }, _toDisplayString(item.id !== 0 ? item.name : '随到随学'), 11, _hoisted_40));
                                }), 256))
                            ])
                        ], 512), [
                            [_vShow, _unref(activeSubType)?.id == 'online']
                        ]),
                        _withDirectives(_createElementVNode("dl", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("dd", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enrollList), (item, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["float-l text-overflow font-28 parent-item", {
                                                active: _unref(activeEnroll)?.id === item.id,
                                                'm-r0': (key + 1) % 3 == 0
                                            }]),
                                        onClick: _withModifiers(($event) => (_unref(selectEnroll)(item)), ["stop"])
                                    }, _toDisplayString(item.name), 11, _hoisted_44));
                                }), 256))
                            ])
                        ], 512), [
                            [_vShow, _unref(activeSubType)?.id == 'online' || _unref(activeType)?.id == 'omo']
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", {
                            class: "reset",
                            onClick: _withModifiers(resetFn, ["stop"])
                        }, "重置", 8, _hoisted_46),
                        _createElementVNode("div", {
                            class: "sure",
                            onClick: _withModifiers(closeFn, ["stop"])
                        }, " 查看" + _toDisplayString(_unref(totalCount) > 99 ? '99+' : _unref(totalCount)) + "课程 ", 9, _hoisted_47)
                    ])
                ], 2)
            ]));
        };
    }
});
